/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicOffers.internal

import features.publicOffers.models.PublicOffersModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class PublicOffersRequest : NetworkRequest() {

    suspend fun getPublicOffers(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<PublicOffersModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicOffersEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
